module.exports = __webpack_public_path__ + "img/navigation-2.a01d7405.svg";